/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Addons_Validity_NoteInputs */

const tr_pricing_addons_validity_note = /** @type {(inputs: Pricing_Addons_Validity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek krediler 12 ay geçerlidir. Aboneliğiniz aktif kaldığı sürece kullanılır.`)
};

const en_pricing_addons_validity_note = /** @type {(inputs: Pricing_Addons_Validity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra credits are valid for 12 months. They can be used as long as your subscription is active.`)
};

const de_pricing_addons_validity_note = /** @type {(inputs: Pricing_Addons_Validity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliche Credits sind 12 Monate gültig und nutzbar, solange Ihr Abonnement aktiv ist.`)
};

const ru_pricing_addons_validity_note = /** @type {(inputs: Pricing_Addons_Validity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные кредиты действительны 12 месяцев. Их можно использовать, пока активна ваша подписка.`)
};

/**
* | output |
* | --- |
* | "Extra credits are valid for 12 months. They can be used as long as your subscription is active." |
*
* @param {Pricing_Addons_Validity_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_addons_validity_note = /** @type {((inputs?: Pricing_Addons_Validity_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Addons_Validity_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_addons_validity_note(inputs)
	if (locale === "de") return de_pricing_addons_validity_note(inputs)
	if (locale === "ru") return ru_pricing_addons_validity_note(inputs)
	return tr_pricing_addons_validity_note(inputs)
});